import React, { useState } from 'react';
import TabBar from '../../../component/tab-bar/tab-bar';
import { PermissionsGroupsTab } from './tabs/groups/permissions-groups-tab';

const tabs = ['קבוצת הרשאות'];

export const SettingsPermissionPage = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const elementTabs = [<PermissionsGroupsTab key="permissions-groups" />];

  return (
    <div className={'studies-settings-root'}>
      <div style={{ width: '100%' }} className={'studies-settings-body-page'}>
        <div className={'studies-settings-title'}>
          הגדרות מערכת - הרשאות משתמשים
        </div>

        <TabBar
          tabs={tabs}
          onClick={(index) => {
            setSelectedIndex(index);
          }}
        />

        {elementTabs[selectedIndex]}
      </div>
    </div>
  );
};
